import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
let RadioBoxGroup = class RadioBoxGroup extends Mixins(WindowSizeListener) {
    constructor() {
        super(...arguments);
        this.selectedOption = this.options[0].index;
    }
    onPreselectChange() {
        if (this.preSelect) {
            this.selectedOption = this.preSelect;
        }
    }
    onOptionsChange() {
        this.selectedOption = this.options[0].index;
        this.$emit('changeOption', this.selectedOption);
    }
    onSelectedOptionChange() {
        this.$emit('changeOption', this.selectedOption);
    }
    get width() {
        if (this.window.width < 1025) {
            return this.window.width * 0.35;
        }
        return 185;
    }
    mounted() {
        if (this.preSelect) {
            this.selectedOption = this.preSelect;
        }
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], RadioBoxGroup.prototype, "options", void 0);
__decorate([
    Prop({ type: Number })
], RadioBoxGroup.prototype, "preSelect", void 0);
__decorate([
    Prop({ type: String, default: 'radio-box' })
], RadioBoxGroup.prototype, "dataCyPrefix", void 0);
__decorate([
    Watch('preSelect')
], RadioBoxGroup.prototype, "onPreselectChange", null);
__decorate([
    Watch('options')
], RadioBoxGroup.prototype, "onOptionsChange", null);
__decorate([
    Watch('selectedOption')
], RadioBoxGroup.prototype, "onSelectedOptionChange", null);
RadioBoxGroup = __decorate([
    Component({})
], RadioBoxGroup);
export default RadioBoxGroup;
